import { Separator } from '@change/ds-core-ui';

import { Waypoint } from '#src/app/shared/components/scroll';

import { InlineShareActions } from './components/InlineShareActions';
import { InlineShareCarouselActions } from './components/InlineShareCarouselActions';
import { ShareSlideUpButton } from './components/ShareSlideUpButton';
import { useShareActions } from './hooks/useShareActions';

export const ShareActions: React.FC<EmptyProps> = () => {
	const {
		data: { variant, display },
		actions: { onPositionChange },
	} = useShareActions();

	if (!display) return null;

	return (
		<div>
			<Waypoint onPositionChange={onPositionChange} />
			<Separator className="mt-0 mb-7" />
			{variant === 'variant_1' && <InlineShareActions />}
			{variant === 'variant_2' && <InlineShareCarouselActions />}
			{variant === 'variant_3' && <ShareSlideUpButton />}
		</div>
	);
};
